"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBTextField = require("../HBTextField/HBTextField.styles");
var _variables = require("../HBTextField/variables");
var _mixins = require("../../styles/mixins");
// Due to a problem with input text alignment, this is a solution for pdf printing.

var MockPrintInput = function MockPrintInput(props) {
  return /*#__PURE__*/_react["default"].createElement(MockInput, {
    inputProps: props
  }, /*#__PURE__*/_react["default"].createElement(InputText, null, props.value || props.placeholder || ''));
};
var _default = exports["default"] = MockPrintInput; // -------------------------------- Styles -------------------------------- //
var MockInput = _styledComponents["default"].div.withConfig({
  displayName: "MockPrintInput__MockInput",
  componentId: "sc-jssic8-0"
})(["", " ", " ", ";", ";"], _mixins.flexCenterVertical, function (props) {
  return (0, _HBTextField.textFieldBaseStyles)(props.inputProps);
}, function (props) {
  return _variables.INPUT_SIZE_PROPS[props.inputProps.scope][props.inputProps.size];
}, (0, _mixins.showInPrintOnly)('flex'));
var InputText = _styledComponents["default"].span.withConfig({
  displayName: "MockPrintInput__InputText",
  componentId: "sc-jssic8-1"
})(["", ""], (0, _mixins.printCss)("\n        ".concat(_mixins.truncatedText, ";\n    ")));
//# sourceMappingURL=MockPrintInput.js.map